module.exports = __webpack_public_path__ + "static/media/5DPO3.40c75d50.jpg";